module.exports = __webpack_public_path__ + "static/media/portfolio4.04dbe3ab.jpg";